module.exports = __webpack_public_path__ + "img/pink_mannequin_1_3.07e76590.png";